import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getInitials, getName } from '../../utils/userUtils';

const Header = ({ username, logo, serviceDeskName, onLogout }) => {
  return (
    <nav className="bg-black p-5 h-[80px] flex items-center">
      <div className="Wrapper w-full max-w-screen-md mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2 rounded-full">
          {logo && (
            <Link to="/home">
              <img src={logo} alt={serviceDeskName} className="w-[120px] h-auto" />
            </Link>
          )}
          {!logo && (
            <Link to="/home">
              <img src="/logo_gps_white.png" alt={'Globe Perfect Store'} className="w-[120px] h-auto" />
            </Link>
          )}
          </div>
        <div className="flex justify-between items-center gap-4">
          {username && (
            <div className="flex flex-row gap-1 items-center gap-2" onClick={onLogout}>
              <span className="text-gray-400 text-base text-[14px] font-medium">
                {getName(username)}
              </span>
              <div className="pb-1 rounded-full w-8 h-8">
                <div className="w-8 h-8 rounded-full bg-[#CDC4BA] flex items-center justify-center">
                  <span className="text-white text-xs font-medium">
                    {getInitials(username)}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

Header.propTypes = {
  username: PropTypes.string.isRequired,
  logo: PropTypes.string,
  serviceDeskName: PropTypes.string,
  onLogout: PropTypes.func.isRequired,
};

export { Header };